import { tv } from 'tailwind-variants';

const styles = tv({
  slots: {
    shadow: `
      pointer-events-none
      absolute
      bottom-0
      left-0
      right-0
      bg-gradient-to-t from-white
      to-transparent
    `,
    markdownContainer: '',
  },
  variants: {
    isCollapsable: {
      true: '',
    },
    isCollapsed: {
      true: '',
    },
  },
  compoundVariants: [
    {
      isCollapsable: true,
      isCollapsed: true,
      className: {
        markdownContainer: `
          relative
          overflow-hidden
        `,
      },
    },
  ],
});

export default styles;
